import api from './api';

/**
 * Service for Peer Support Assignments
 * Assignments are the source of truth for staffing
 */
export const assignmentService = {
    /**
     * Get all assignments for current user (as peer supporter)
     */
    async getMyAssignments() {
        const response = await api.get('/assignment/mine');
        return response.data;
    },

    /**
     * Get assignment by ID
     */
    async getAssignmentById(assignmentId) {
        const response = await api.get(`/assignment/${assignmentId}`);
        return response.data;
    },

    /**
     * Get assignments for a program (coordinator view)
     * @param {string} programType - 'si', 'ta', or 'la'
     */
    async getAssignmentsByProgram(programType, filters = {}) {
        const response = await api.get(`/assignment/program/${programType}`, {
            params: filters,
        });
        return response.data.assignments;
    },

    /**
     * The program's onboarding email filled in for this assignment's student
     */
    async getOnboardingDraft(assignmentId) {
        const response = await api.get(
            `/assignment/${assignmentId}/onboarding-draft`
        );
        return response.data;
    },

    /**
     * Send the onboarding email; resolves to { sentAt, sentBy: { name } }
     */
    async sendOnboardingEmail(assignmentId, message) {
        const response = await api.post(
            `/assignment/${assignmentId}/onboarding-email`,
            { message }
        );
        return response.data;
    },

    /**
     * Create a new assignment (from approved application or direct hire)
     * @param {Object} assignmentData - Assignment data including:
     *   - studentId: The peer supporter being assigned
     *   - courseId: The course
     *   - programType: 'si', 'ta', or 'la'
     *   - sectionIds: Array of section IDs (optional)
     *   - startDate, endDate: Assignment period
     *   - hoursPerWeek: Expected hours
     */
    async createAssignment(assignmentData) {
        const response = await api.post('/assignment', assignmentData);
        return response.data;
    },

    /**
     * Update an assignment
     */
    async updateAssignment(assignmentId, assignmentData) {
        const response = await api.put(
            `/assignment/${assignmentId}`,
            assignmentData
        );
        return response.data;
    },

    /**
     * Get upcoming sessions for the current user
     * Returns a flat array of session objects from all active assignments.
     */
    async getUpcomingSessions() {
        const response = await api.get('/assignment/sessions');
        return response.data;
    },
};

export default assignmentService;
